export const PROJECTS_SUMMARY_FILTER_TABS = {
  ALL_PROJECTS: 'ALL_PROJECTS',
  MY_PROJECTS: 'MY_PROJECTS'
};

export const PORTFOLIO_PROJECTS_SUMMARY_FILTER_TABS = {
  THIS_PORTFOLIO: 'THIS_PORTFOLIO',
  SUB_PORTFOLIOS: 'SUB_PORTFOLIOS'
};
